import { API_BASE_URL } from "../config/apiBaseUrl";
import { FEATURED_ANALYTICS_EVENTS } from "../constants/automapFeaturedPlacementConstants";

const ADMIN_BASE = "/api/admin/automotive";
const PORTAL_BASE = "/api/v1/automap/dealer-portal";
const PUBLIC_BASE = "/api/v1/automap";

function authHeaders() {
  return { credentials: "include", headers: { "Content-Type": "application/json" } };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") search.set(k, v);
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchPlacementsDashboard() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/dashboard`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar placements.");
  return res.json();
}

export async function fetchListingPlacements(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/listings${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar placements de listings.");
  return res.json();
}

export async function fetchDealerPlacements(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/dealers${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar placements de dealers.");
  return res.json();
}

export async function fetchPlacementSchedule(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/schedule${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar calendario.");
  return res.json();
}

export async function fetchPlacementPerformance(filters = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/performance${qs(filters)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar performance.");
  return res.json();
}

export async function fetchPlacementRules() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/rules`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar reglas.");
  return res.json();
}

export async function createPlacement(body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "No se pudo crear placement.");
  }
  return res.json();
}

export async function updatePlacement(placementId, body) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/${encodeURIComponent(placementId)}`, {
    method: "PATCH",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("No se pudo actualizar placement.");
  return res.json();
}

export async function pausePlacement(placementId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/${encodeURIComponent(placementId)}/pause`, {
    method: "POST",
    ...authHeaders(),
  });
  if (!res.ok) throw new Error("No se pudo pausar.");
  return res.json();
}

export async function cancelPlacement(placementId, reason) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/placements/${encodeURIComponent(placementId)}/cancel`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify({ reason }),
  });
  if (!res.ok) throw new Error("No se pudo cancelar.");
  return res.json();
}

export async function fetchPublicPlacementsFeed(params = {}) {
  const res = await fetch(`${API_BASE_URL}${PUBLIC_BASE}/placements/feed${qs(params)}`);
  if (!res.ok) return { feed: { slots: {} } };
  return res.json();
}

export async function fetchDealerFeaturedPortal(dealerId) {
  const res = await fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/featured`, authHeaders());
  if (!res.ok) throw new Error("Could not load featured placements.");
  return res.json();
}

export async function fetchDealerSponsorships(dealerId, params = {}) {
  const search = new URLSearchParams();
  if (params.range) search.set("range", params.range);
  const q = search.toString();
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/sponsorships${q ? `?${q}` : ""}`,
    authHeaders()
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || "Could not load sponsorships.");
  }
  return res.json();
}

export async function fetchAdminDealerFeatured(dealerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/featured`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar destacados del dealer.");
  return res.json();
}

export async function requestFeaturedPlacement(dealerId, body) {
  const res = await fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/featured/requests`, {
    method: "POST",
    ...authHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || "Could not submit boost request.");
  }
  return res.json();
}

export async function postFeaturedPlacementAnalytics(payload) {
  await fetch(`${API_BASE_URL}${PUBLIC_BASE}/placements/analytics`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => {});
}

export function trackFeaturedClick(payload) {
  return postFeaturedPlacementAnalytics({
    eventName: FEATURED_ANALYTICS_EVENTS.CLICKED,
    ...payload,
  });
}

export function trackFeaturedImpression(payload) {
  return postFeaturedPlacementAnalytics({
    eventName: FEATURED_ANALYTICS_EVENTS.IMPRESSION,
    ...payload,
  });
}
